// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationFollowUpPatientAddress } from './priorAuthorizationFollowUpPatientAddress.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationFollowUpPatient {
    'address': PriorAuthorizationFollowUpPatientAddress | null;
    'birthDate': Moment | null;
    'firstName': string | null;
    'lastName': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationFollowUpPatient>> = [
        {
            "name":     "address",
            "baseName": "address",
            "type":     "PriorAuthorizationFollowUpPatientAddress"
        },
        {
            "name":     "birthDate",
            "baseName": "birthDate",
            "type":     "Date"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationFollowUpPatient.attributeTypeMap;
    }
}
